import { APP_BASE_HREF } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MATERIAL_SANITY_CHECKS } from '@angular/material/core';
import { BrowserModule, Meta } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MissingTranslationHandler, TranslateModule } from '@ngx-translate/core';
import { MarkdownModule, MarkedOptions } from 'ngx-markdown';
import 'hammerjs';

import { AppInjector } from './app-injector.service';
import { AppComponent } from './app.component';
import { appInitializerFactory } from './app.initialize';
import { AppService } from './app.service';
import { LayoutModule } from './layout/layout.module';
import { LegalNoticeModule } from './legal-notice/legal-notice.module';
import { markedOptionsFactory } from './marked-options-factory';
import { RequestInterceptor } from './request.interceptor';
import { RoutingModule } from './routing/routing.module';
import { PreloadService } from './routing/services/preload.service';
import { PreviousRouteService } from './routing/services/previous-route.service';
import { ThemeService } from './shared/theme/services/theme.service';
import { TokenInterceptor } from './token.interceptor';
import { MyMissingTranslationHandler } from './translator';
import { AudioModule } from './audio/audio.module';
import { TranslationService } from './translation/services/translation.service';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    RoutingModule,
    LayoutModule,
    LegalNoticeModule,
    TranslateModule.forRoot(),
    // NgxSmartModalModule.forRoot(),
    MarkdownModule.forRoot({
      markedOptions: {
        provide: MarkedOptions,
        useFactory: markedOptionsFactory,
      },
    }),
    AudioModule,
  ],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: APP_BASE_HREF,
      useValue: '/',
    },
    PreviousRouteService,
    PreloadService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [AppService, TranslationService, ThemeService, Meta],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: MissingTranslationHandler,
      useClass: MyMissingTranslationHandler,
    },
    {
      provide: MATERIAL_SANITY_CHECKS,
      useValue: false,
    },
  ],
})
export class AppModule {

  /**
   * Constructor
   *
   * @param injector
   */
  public constructor(private injector: Injector) {
    AppInjector.injector = injector;
  }
}
